export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

export const handleClickScroll = (id) => {
  const element = document.getElementById(id);
  if (element) {
    // Get the header height with extra padding to ensure content is fully visible
    const headerHeight = 120;
    const elementPosition = element.offsetTop;
    const offsetPosition = elementPosition - headerHeight;

    // 👇 Will scroll smoothly to the element with header offset
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }
};
